import { getCurrencyHtml } from "./get-currency-html";

export function getSlideHtml(product, id = -1, containerClassName = '') {
  const currencyHtml = getCurrencyHtml(product.currency);
  let productImage = '';
  if (typeof product.img === 'string') {
    productImage = product.img;
  } else if (Array.isArray(product.img)) {
    productImage = product.img[0];
  }
  return `
    <div class="vjs-stream-shopping-slider__slide ${containerClassName}" data-product-id="${id}">
      <div class="vjs-stream-shopping-slider__img">
        <img src="${productImage}" />
      </div>
      <div class="vjs-stream-shopping-slider__info">
        <div class="vjs-stream-shopping-slider__top">
          <div class="vjs-stream-shopping-slider-text">
            <div class="vjs-stream-shopping-slider__title">${product.title}</div>
            <!--div class="vjs-stream-shopping-slider__description">${product.description || ''}</div-->
          </div>
          <button class="vjs-stream-shopping-slider__button-details">
            <svg width="6" height="14" viewBox="0 0 6 14" fill="none"><path opacity="0.2" d="M1 1L5 7L1 13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
        <div class="vjs-stream-shopping-slider__bottom">
          <div class="vjs-stream-shopping-slider__price">
            <div class="vjs-stream-shopping-slider__new-price">
              ${product.price} ${currencyHtml}
            </div>
            <div class="vjs-stream-shopping-slider__old-price">
              ${product.oldPrice * 1 ? product.oldPrice + ' ' + currencyHtml : ''}
            </div>
          </div>
          <a href="${product.url}" class="vjs-stream-shopping-slider__buy" target="_blank" rel="noopener noreferrer">К товару</a>
        </div>
      </div>
    </div>
  `;
}
